import { createContext, useContext } from "react";

type AccordionContextValue = {
  activeId: string;
  onAccordionClick: (activeId: string) => void;
};

export const AccordionContext = createContext<AccordionContextValue | undefined>(undefined);

export const useAccordion = () => {
  const context = useContext(AccordionContext);

  if (!context) {
    throw new Error(`Accordion components must be within the Accordion context`);
  }

  return context;
};

export const useAccordionContext = () => {
  const context = useContext(AccordionContext);

  if (!context) {
    return null;
  }

  return context;
};
